const VI = {
  Lang: {
    Code: "VN",
    TextEN: "Tiếng Anh",
    TextVN: "Tiếng Việt",
  },
  Login: {
    ErrorEmail: "Vui lòng nhập email!",

    LoginDescription: "Nhập email và mật khẩu của bạn để đăng nhập.",
    ButtonText: "Đăng nhập",
  },
  hero: {
    title: "Công cụ AI đa năng của bạn",
    description:
      "Dịch ngôn ngữ, dịch file nhanh chóng với công nghệ AI tiên tiến",
  },

  tabs: {
    translate: "Dịch ngôn ngữ",
    file: "Dịch File",
    compress: "Nén ảnh",
  },

  file: {
    section_title: "Dịch File",
    section_description:
      "Upload file và dịch toàn bộ nội dung sang ngôn ngữ khác",
    from_language: "Ngôn ngữ nguồn",
    to_language: "Ngôn ngữ đích",
    drag_text: "Kéo thả file vào đây hoặc",
    choose_file: "Chọn file",
    support_text: "Hỗ trợ DOC, DOCX, XLSX, PPTX, PDF",
    translating: "Đang dịch tài liệu...",
    translating_short: "📄 Đang dịch",
    // translating_processing: "📄 Tệp đang được dịch toàn bộ tài liệu",
    translating_short_complete: "📄 Đang dịch toàn bộ tài liệu",
    translate_now: "Dịch ngay",
  },

  note: {
    review_note_before: "Lưu ý: Bạn có",
    review_note_after:
      "lượt xem trước tài liệu. Nếu hết lượt, vui lòng thanh toán để nhận lại lượt xem trước tài liệu.",
    line1: "● Dịch nhiều định dạng: Word, Excel, PPTX...",
    line2:
      "● Giữ nguyên layout bảng biểu, hình ảnh, được xem trước bản dịch trước khi thanh toán.",
    line3: "● Hỗ trợ nhiều ngôn ngữ phổ biến và chuyên ngành",
    line4: "● Xử lý nhanh, dễ sử dụng, không cần kỹ thuật.",
    line5: "● Lưu lịch sử dịch thuật thuận tiện cho người dùng tải về.",
    warning:
      "* Lưu ý ngôn ngữ sau khi dịch số lượng từ có thể dài hoặc ngắn hơn so với layout gốc, bạn hãy chỉnh lại font chữ cho phù hợp với layout.",
  },

  preview: {
    loading_title: "Đang chuẩn bị bản xem trước...",
    loading_desc: "AI đang render tài liệu, vui lòng chờ trong giây lát.",
    title: "📄 Xem trước tài liệu",
    note: "Thanh toán ngay để tải về bản dịch hoàn chỉnh.",
    choose_payment_method: "Chọn phương thức thanh toán",
    payment: "Thanh toán",
    download: "Tải về",
    must_pay: "Vui lòng thanh toán trước khi tải về",
  },

  feature: {
    format: {
      title: "Nhiều định dạng",
      desc: "Hỗ trợ PDF, Word, TXT",
    },
    security: {
      title: "Bảo mật",
      desc: "File được mã hóa an toàn",
    },
    layout: {
      title: "Giữ nguyên định dạng",
      desc: "Bảo toàn layout gốc",
    },
  },

  auth: {
    login_required: "Vui lòng đăng nhập để sử dụng chức năng!",
    loginSuccess: "Đăng nhập thành công",
    loginFailed: "❌ Đăng nhập thất bại",
  },

  error: {
    upload_fail: "❌ Lỗi không tải được file",
    unsupported_format: "❌ Định dạng file không được hỗ trợ",
    translate_fail:
      "❌ Hiện tại máy chủ đang trong quá trình bảo trì nên không thể dịch tệp vào lúc này. Vui lòng thử lại sau. Xin lỗi vì sự bất tiện này.",
    qr_fail: "❌ Lấy mã thanh toán thất bại",
  },
  pdf: {
    selectPdfProcessingModeBeforeStart:
      "File PDF cần chọn kiểu xử lý trước khi bắt đầu dịch.",
    selectPdfTranslationMode: "Chọn kiểu dịch PDF",
    only_text: {
      title: "Chỉ dịch văn bản, giữ nguyên hình gốc",
      desc: "Giữ nguyên hình ảnh và bố cục PDF, chỉ dịch phần nội dung văn bản. File sau dịch có thể chỉnh sửa.",
    },
    text_or_image: {
      title: "Dịch toàn bộ nội dung và hình ảnh trong file",
      desc: "Dịch cả văn bản và nội dung chữ trong hình ảnh, đồng thời giữ nguyên bố cục file. File sau dịch có thể chỉnh sửa.",
    },
    full_image: {
      title: "Dịch thành PDF dạng hình ảnh",
      desc: "Xuất kết quả dưới dạng PDF chứa hình ảnh sau khi dịch.",
    },
  },

  common: {
    close: "Đóng",
    loading: "Đang tải...",
    noData: "Không có dữ liệu",
    loadMore: "Xem thêm",
    ok: "Đồng ý",
    delete: "Xóa",
  },
  menu: {
    home: "Trang chủ",
    blog: "Blog",
    faq: "Faq",
  },

  user: {
    transactionHistory: "Lịch sử giao dịch",
    logout: "Đăng xuất",
  },

  blog: {
    notFound: "Không tìm thấy bài viết",
    relatedPosts: "Bài viết liên quan",
    authorAdmin: "Admin",
    pageTitle: "Blog & Chia sẻ",
    pageDescription: "Kiến thức, hướng dẫn và cập nhật mới nhất về AI Tools",
    noMorePosts: "Đã hiển thị tất cả bài viết",
  },

  seo: {
    blogTitleFallback: "Dịch tài liệu online | MikoTech",
    blogDescriptionFallback:
      "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh.",
    blogKeywordsFallback: "dịch tài liệu, dịch file pdf, dịch tiếng anh",
  },
  payment: {
    complete: {
      title: "Thông tin file đã thanh toán",
    },

    fileName: "Tên file",
    fileSize: "Dung lượng",
    translateFrom: "Dịch từ",
    paymentStatus: "Thanh toán",

    paid: "Đã thanh toán",
    unpaid: "Chưa thanh toán",

    download: "Tải về",
    transactionNotFound: "Lỗi không tìm thấy mã giao dịch",
    expirationDate: "Ngày hết hạn",
  },
  transaction: {
    title: "Lịch sử giao dịch",
    note: "Danh sách các file đã upload để dịch. Bạn có thể thanh toán hoặc tải về file đã dịch sau khi hoàn tất thanh toán.",
    fileDeleted: "Tệp này đã bị xóa",
    notiteDeleteFile: "Bạn có chắc muốn xóa file này?",
    searchPlaceholder: "Tìm kiếm theo tên file...",

    table: {
      fileName: "Tên file",
      fileSize: "Dung lượng",
      language: "Ngôn ngữ",
      status: "Trạng thái",
      price: "Giá",
      action: "Hành động",
      expirationDate: "Ngày hết hạn",
    },

    status: {
      all: "Tất cả trạng thái",
      paid: "Đã thanh toán",
      unpaid: "Chưa thanh toán",
    },
    delete: "Xóa",
    download: "Tải về",
    pay: "Thanh toán",
    mustPayFirst: "Vui lòng thanh toán trước khi tải về",
    getQrFail: "Lấy mã thanh toán thất bại",
  },

  pagination: {
    prev: "Trước",
    next: "Sau",
  },
  faq: {
    title: "Những câu hỏi thường gặp",
    description:
      "Bạn cần hiểu thêm về dịch vụ dịch tài liệu? Tham khảo các lời giải đáp dưới đây nhé!",
  },
  translate: {
    terms:
      "Bằng việc tiếp tục, tôi xác nhận đồng ý với các <termsLink>điều khoản và chính sách</termsLink> của nền tảng, đồng thời chịu mọi trách nhiệm đối với bản dịch do mình thực hiện.",
    selectTone: "Chọn ngữ điệu",
    analyzing_document: "Đang phân tích tài liệu...",
    extracting_content: "Đang trích xuất nội dung...",
    ai_translating: "Đang dịch bằng AI...",
    rebuilding_layout: "Đang tái tạo bố cục...",
    finalizing_document: "Đang hoàn tất tài liệu...",
    ai_processing:
      "Đang xử lý tài liệu. Quá trình sẽ tự chạy liên tục cho đến khi hoàn tất.",
    NotitePdf:
      " File .PDF hiện chỉ hỗ trợ dịch nội dung văn bản trong file, chưa thể giữ nguyên định dạng gốc. Kết quả xuất ra sẽ là file chứa nội dung đã dịch dưới dạng văn bản thuần.",
  },
  translation: {
    fileRetentionNotice: "Lưu ý: File sẽ bị xóa sau 30 ngày.",
    keepThisPageOpen:
      "Vui lòng giữ nguyên trang này. Khi dịch xong, hệ thống sẽ tự động đóng màn hình xử lý và mở bản xem trước.",
    emailNotice:
      "Khi tài liệu được dịch hoàn thành, hệ thống sẽ gửi email thông báo đến bạn.",
  },
  footer: {
    productOf: "© 2026. Sản phẩm của Miko Tech",

    description:
      "Nền tảng hỗ trợ dịch tài liệu trực tuyến bằng AI, giúp xử lý file nhanh chóng, dễ sử dụng và bảo mật.",
    badge: "Nền tảng dịch thuật AI",
    contactTitle: "Thông tin liên hệ",
    supportTitle: "Chính sách hỗ trợ",

    copyright: "© 2026 Docme.vn. Sản phẩm của Miko Tech.",
    terms: "Điều khoản",
    privacy: "Bảo mật",

    supportLinks: {
      termsAndPolicies: "Chính sách & Điều khoản sử dụng",
      paymentPolicy: "Chính sách thanh toán",
      privacyPolicy: "Chính sách bảo mật",
      userGuide: "Hướng dẫn sử dụng",
      contactInfo: "Thông tin liên hệ",
    },
  },
  fileSizeModal: {
    title: "File vượt quá dung lượng cho phép",
    heading: "Dung lượng file quá lớn",
    descBefore: "File bạn vừa chọn có dung lượng",
    descAfter: "Hệ thống chỉ hỗ trợ file tối đa",
    confirm: "Tôi đã hiểu",
  },
  address:
    "Tầng 4B, 485B Nguyễn Đình Chiểu, Phường Bàn Cờ, Thành phố Hồ Chí Minh, Việt Nam",
};

export default VI;
